import { classNames } from 'shared/lib/classNames/classNames';
import { useApi } from 'app/api/APIProvider';
import { PolicyBanner } from './ui/PolicyBanner/PolicyBanner';
import { PolicyWork } from './ui/PolicyWork/PolicyWork';
import { PolicyRegister } from './ui/PolicyRegister/PolicyRegister';
import { PolicyTable } from './ui/PolicyTable/PolicyTable';
import { PolicyCondition } from './ui/PolicyCondition/PolicyCondition';
import cls from './GoodCard.module.scss';
import { ReactNode } from 'react';

export enum PolicyCardTheme {
    banner = 'banner',
    works = 'works',
    register= 'register',
    table= 'table',
    condition= 'condition',
}

interface IBanner {
    name: string,
    description: string,
    img: string,
    button: {
        text: string,
        url?: string,
        boughtText?: string,
    },
    cost?: string,
    unique_key?: string,
    type: string,
}

interface ICard {
    text: string,
    iconIndex: number,
};

interface IForm {
    text: string,
    initialSum: boolean,
    yearSum: boolean,
    fieldText?: {
        initialSumText?: string,
        yearSumText?: string,
        additionText?: string,
    },
    showDescription?: boolean,
    buttonText: string,
    productKey: string,
};

interface ITables {
    rightCell: string,
    leftCell: string,
}

interface PolicyCardProps {
    banner?: IBanner,
    cards?: ICard[],
    table?: {
        titles: string[],
        tables: ITables[],
    },
    form?: IForm,
    isPaid?: boolean,
    callback?: () => void,
    theme: PolicyCardTheme,
}

export const PolicyCard = ({ banner, cards, form, table, isPaid, callback, theme }: PolicyCardProps) => {
    const api = useApi();

    return (
        <>
            {
                theme === 'banner' && <PolicyBanner banner={banner} isPaid={isPaid} callback={callback} />
            }
            {
                theme === 'works' && <PolicyWork cards={cards} />
            }
            {
                theme === 'register' && <PolicyRegister form={form} callback={callback} />
            }
            {
                theme === 'table' && <PolicyTable table={table} />
            }
            {
                theme === 'condition' && <PolicyCondition/>
            }
        </>
    );
};
